// extracted by mini-css-extract-plugin
export var active = "index-module--active--7s4vn";
export var image = "index-module--image--oxae8";
export var inner = "index-module--inner--Cp3-N";
export var intrinsic = "index-module--intrinsic--LTOxT";
export var ratioA = "index-module--ratioA--ezHKQ";
export var ratioB = "index-module--ratioB--QRUa0";
export var ratioC = "index-module--ratioC--yEU-R";
export var ratioD = "index-module--ratioD--tLL9m";
export var ratioE = "index-module--ratioE--RNavO";
export var ratioF = "index-module--ratioF--5HwZs";
export var ratioG = "index-module--ratioG--TK6xB";
export var ratioH = "index-module--ratioH--uY71f";
export var ratioI = "index-module--ratioI--nyccj";